
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-thiruvarur",
      function () {
        return require("private-next-pages/tnpsc-thiruvarur/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-thiruvarur"])
      });
    }
  